function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 17.23,
    height: 9.11,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.9109999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 4.555
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.11,
    width: 17.23,
    height: 9.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 14.03
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18.95,
    width: 17.23,
    height: 9.9,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4142857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 23.9
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28.85,
    width: 17.23,
    height: 9.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.422857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 33.83
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 38.8,
    width: 17.23,
    height: 11.17,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.39625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 44.385
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 49.97,
    width: 17.23,
    height: 12.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.146666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 56.41
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 62.85,
    width: 17.23,
    height: 13.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.016923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 69.46000000000001
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 76.07,
    width: 17.23,
    height: 13.99,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 83.065
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 90.06,
    width: 17.23,
    height: 16.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3280000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 98.38
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 106.7,
    width: 17.23,
    height: 17.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4614285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 115.325
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 123.95,
    width: 17.23,
    height: 20.67,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4614285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 134.285
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 144.61,
    width: 17.23,
    height: 20.85,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 155.03500000000003
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 165.47,
    width: 17.23,
    height: 21.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 176.035
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 186.59,
    width: 17.23,
    height: 21.4,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4614285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 197.29
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 207.99,
    width: 17.23,
    height: 21.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.15375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 218.74
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 229.49,
    width: 17.23,
    height: 22.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.15375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 240.83
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 252.17,
    width: 17.23,
    height: 23.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 263.91499999999996
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 275.67,
    width: 17.23,
    height: 23.55,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 287.445
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 299.21,
    width: 17.23,
    height: 23.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 311.16999999999996
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 323.13,
    width: 17.23,
    height: 25.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 335.8
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 348.48,
    width: 17.23,
    height: 25.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 361.43
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 374.38,
    width: 17.23,
    height: 26.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 387.83
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 401.28,
    width: 17.23,
    height: 27.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.723
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 415.02
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 428.76,
    width: 17.23,
    height: 27.72,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 442.62
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 456.48,
    width: 17.23,
    height: 28.14,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.15375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 470.55
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 484.61,
    width: 17.23,
    height: 28.4,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4614285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 498.81
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 513.01,
    width: 17.23,
    height: 29.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4614285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 527.915
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 542.82,
    width: 17.23,
    height: 30.45,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 558.0450000000001
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 573.27,
    width: 17.23,
    height: 30.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.15375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 588.6899999999999
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 604.11,
    width: 17.23,
    height: 31.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.15375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 619.865
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 635.62,
    width: 17.23,
    height: 31.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4614285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 651.41
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 667.2,
    width: 17.23,
    height: 32.8,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.446
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.615,
    y: 683.6
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 0,
    width: 22.36,
    height: 25.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4719999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 28.41,
    y: 12.995
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.59,
    y: 0,
    width: 22.41,
    height: 25.99,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2014285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.795,
    y: 12.995
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.99,
    y: 0,
    width: 22.53,
    height: 25.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.218571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.255,
    y: 12.995
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.52,
    y: 0,
    width: 22.6,
    height: 25.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2285714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.82,
    y: 12.995
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 0,
    width: 22.88,
    height: 25.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.576
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.56,
    y: 12.995
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.01,
    y: 0,
    width: 23.22,
    height: 25.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.644
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.62,
    y: 12.995
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 153.23,
    y: 0,
    width: 24.29,
    height: 25.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4699999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 165.375,
    y: 12.995
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.52,
    y: 0,
    width: 25.36,
    height: 25.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6228571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.20000000000002,
    y: 12.995
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.88,
    y: 0,
    width: 25.56,
    height: 25.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.112
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.66,
    y: 12.995
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.43,
    y: 0,
    width: 25.9,
    height: 25.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.38,
    y: 12.995
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.33,
    y: 0,
    width: 26.03,
    height: 25.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1979999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.345,
    y: 12.995
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.36,
    y: 0,
    width: 26.25,
    height: 25.99,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.331666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.485,
    y: 12.995
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.6,
    y: 0,
    width: 27.15,
    height: 25.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8877777777777776
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.175,
    y: 12.995
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.76,
    y: 0,
    width: 27.22,
    height: 25.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.24875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 347.37,
    y: 12.995
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.98,
    y: 0,
    width: 27.86,
    height: 25.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.24875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.91,
    y: 12.995
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.83,
    y: 0,
    width: 28.63,
    height: 25.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.331666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.145,
    y: 12.995
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417.46,
    y: 0,
    width: 28.63,
    height: 25.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.4975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 431.775,
    y: 12.995
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 446.1,
    y: 0,
    width: 29.23,
    height: 25.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.331666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 460.71500000000003,
    y: 12.995
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.33,
    y: 0,
    width: 30.65,
    height: 25.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5989999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 490.655,
    y: 12.995
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.97,
    y: 0,
    width: 31.62,
    height: 25.99,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1979999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 521.78,
    y: 12.995
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 537.59,
    y: 0,
    width: 31.84,
    height: 25.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5989999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 553.51,
    y: 12.995
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.42,
    y: 0,
    width: 32.02,
    height: 25.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7128571428571426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.43,
    y: 12.995
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.44,
    y: 0,
    width: 32.61,
    height: 25.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1979999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 617.745,
    y: 12.995
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.05,
    y: 0,
    width: 32.91,
    height: 25.99,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1979999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.505,
    y: 12.995
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 666.96,
    y: 0,
    width: 33.04,
    height: 25.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.331666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.48,
    y: 12.995
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 25.99,
    width: 31.91,
    height: 27,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 39.489999999999995
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 52.98,
    width: 31.91,
    height: 27.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 66.75999999999999
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 80.54,
    width: 31.91,
    height: 27.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.613333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 94.38000000000001
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 108.22,
    width: 31.91,
    height: 27.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9857142857142853
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 122.17
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 136.12,
    width: 31.91,
    height: 28.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 150.56
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 165,
    width: 31.91,
    height: 29.85,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 179.925
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 194.85,
    width: 31.91,
    height: 30.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.121666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 210.215
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 225.58,
    width: 31.91,
    height: 30.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.184
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 241.04000000000002
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 256.5,
    width: 31.91,
    height: 31.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.316
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 272.29
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 288.08,
    width: 31.91,
    height: 32.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5455555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 304.53499999999997
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 320.99,
    width: 31.91,
    height: 33.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.382
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 337.57
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 354.15,
    width: 31.91,
    height: 33.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.98875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 370.73499999999996
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 387.32,
    width: 31.91,
    height: 33.32,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.382
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 403.98
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 420.63,
    width: 31.91,
    height: 34.07,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.98875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 437.665
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 454.7,
    width: 31.91,
    height: 34.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.98875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 471.84499999999997
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 488.99,
    width: 31.91,
    height: 34.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.318333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 506.295
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 523.59,
    width: 31.91,
    height: 34.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.382
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 540.965
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 558.34,
    width: 31.91,
    height: 34.87,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.318333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 575.775
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 593.21,
    width: 31.91,
    height: 34.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.318333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 610.6550000000001
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 628.11,
    width: 31.91,
    height: 35.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.382
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 646.03
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.23,
    y: 663.94,
    width: 31.91,
    height: 36.06,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.558571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.185,
    y: 681.97
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 25.99,
    width: 32.59,
    height: 36.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.655714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.435,
    y: 44.12
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.73,
    y: 25.99,
    width: 32.78,
    height: 36.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.463333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.12,
    y: 44.12
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.51,
    y: 25.99,
    width: 33.7,
    height: 36.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.744444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.36,
    y: 44.12
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.21,
    y: 25.99,
    width: 34.08,
    height: 36.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 165.25,
    y: 44.12
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.3,
    y: 25.99,
    width: 34.82,
    height: 36.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.482
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.71,
    y: 44.12
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.11,
    y: 25.99,
    width: 34.88,
    height: 36.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.976000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 234.55,
    y: 44.12
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251.99,
    y: 25.99,
    width: 34.91,
    height: 36.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4909999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.445,
    y: 44.12
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.9,
    y: 25.99,
    width: 35.13,
    height: 36.26,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.018571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.465,
    y: 44.12
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.03,
    y: 25.99,
    width: 36.2,
    height: 36.26,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.13,
    y: 44.12
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.22,
    y: 25.99,
    width: 36.65,
    height: 36.26,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.252
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.545,
    y: 44.12
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.87,
    y: 25.99,
    width: 36.73,
    height: 36.26,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.252
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.235,
    y: 44.12
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 431.61,
    y: 25.99,
    width: 37.13,
    height: 36.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.252
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 450.175,
    y: 44.12
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.74,
    y: 25.99,
    width: 37.14,
    height: 36.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.252
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.31,
    y: 44.12
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.87,
    y: 25.99,
    width: 37.52,
    height: 36.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.043333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.63,
    y: 44.12
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.39,
    y: 25.99,
    width: 38.35,
    height: 36.26,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.043333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.5649999999999,
    y: 44.12
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 581.75,
    y: 25.99,
    width: 39.22,
    height: 36.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 601.36,
    y: 44.12
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.96,
    y: 25.99,
    width: 39.24,
    height: 36.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.043333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.58,
    y: 44.12
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660.2,
    y: 25.99,
    width: 39.8,
    height: 36.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 680.1,
    y: 44.12
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 62.24,
    width: 41.04,
    height: 36.25,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 80.36500000000001
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 98.49,
    width: 41.04,
    height: 36.75,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 116.865
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 135.24,
    width: 41.04,
    height: 36.8,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.359999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 153.64000000000001
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 172.04,
    width: 41.04,
    height: 37.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.418000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 190.58499999999998
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 209.13,
    width: 41.04,
    height: 37.55,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.69375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 227.905
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 246.68,
    width: 41.04,
    height: 37.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.385714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 265.53000000000003
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 284.38,
    width: 41.04,
    height: 38.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.616
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 303.42
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 322.46,
    width: 41.04,
    height: 38.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 341.705
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 360.95,
    width: 41.04,
    height: 38.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.81375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 380.205
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 399.46,
    width: 41.04,
    height: 38.57,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.428333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 418.745
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 438.03,
    width: 41.04,
    height: 39.36,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 457.71
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 477.4,
    width: 41.04,
    height: 43.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 499.075
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 520.75,
    width: 41.04,
    height: 44.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 542.885
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 565.02,
    width: 41.04,
    height: 44.55,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 587.295
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 609.57,
    width: 41.04,
    height: 44.58,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 631.86
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.14,
    y: 654.15,
    width: 41.04,
    height: 45.85,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.66,
    y: 677.0749999999999
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.18,
    y: 62.24,
    width: 40.19,
    height: 46.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.741428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.275,
    y: 85.64500000000001
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.37,
    y: 62.24,
    width: 40.77,
    height: 46.81,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.1925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.755,
    y: 85.64500000000001
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.14,
    y: 62.24,
    width: 40.79,
    height: 46.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.798333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.535,
    y: 85.64500000000001
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.93,
    y: 62.24,
    width: 41.63,
    height: 46.81,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.4075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.745,
    y: 85.64500000000001
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.56,
    y: 62.24,
    width: 42.93,
    height: 46.81,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.025,
    y: 85.64500000000001
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.48,
    y: 62.24,
    width: 45.01,
    height: 46.81,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.501666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.985,
    y: 85.64500000000001
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.5,
    y: 62.24,
    width: 46.9,
    height: 46.81,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.687142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.95,
    y: 85.64500000000001
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.4,
    y: 62.24,
    width: 48.6,
    height: 46.81,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.801666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.7,
    y: 85.64500000000001
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 437,
    y: 62.24,
    width: 48.78,
    height: 46.81,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.801666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.39,
    y: 85.64500000000001
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.78,
    y: 62.24,
    width: 48.88,
    height: 46.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.687142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.21999999999997,
    y: 85.64500000000001
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 534.65,
    y: 62.24,
    width: 49.19,
    height: 46.81,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.801666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.245,
    y: 85.64500000000001
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.84,
    y: 62.24,
    width: 56.57,
    height: 46.81,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.687142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.125,
    y: 85.64500000000001
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640.42,
    y: 62.24,
    width: 59.58,
    height: 46.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.687142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.2099999999999,
    y: 85.64500000000001
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.18,
    y: 109.05,
    width: 56.11,
    height: 51.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.23500000000001,
    y: 134.93
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.18,
    y: 160.81,
    width: 56.11,
    height: 59.59,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.015714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.23500000000001,
    y: 190.60500000000002
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.18,
    y: 220.4,
    width: 56.11,
    height: 59.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.23500000000001,
    y: 250.335
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.18,
    y: 280.27,
    width: 56.11,
    height: 61.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.23500000000001,
    y: 311.16499999999996
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.18,
    y: 342.06,
    width: 56.11,
    height: 63.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.23500000000001,
    y: 373.83
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.18,
    y: 405.6,
    width: 56.11,
    height: 64.17,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.23500000000001,
    y: 437.685
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.18,
    y: 469.77,
    width: 56.11,
    height: 75.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.23500000000001,
    y: 507.405
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.18,
    y: 545.04,
    width: 56.11,
    height: 76.61,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.23500000000001,
    y: 583.3449999999999
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.18,
    y: 621.64,
    width: 56.11,
    height: 78.36,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.234444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.23500000000001,
    y: 660.8199999999999
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.28,
    y: 109.05,
    width: 62.24,
    height: 73.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.4,
    y: 145.82
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.52,
    y: 109.05,
    width: 63.23,
    height: 73.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.90375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.13500000000002,
    y: 145.82
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.76,
    y: 109.05,
    width: 65.24,
    height: 73.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.319999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.38,
    y: 145.82
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 109.05,
    width: 66.04,
    height: 73.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.434285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.02,
    y: 145.82
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.04,
    y: 109.05,
    width: 68.82,
    height: 73.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.764
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 437.45000000000005,
    y: 145.82
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.85,
    y: 109.05,
    width: 74.15,
    height: 73.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.256666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 508.925,
    y: 145.82
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546,
    y: 109.05,
    width: 74.56,
    height: 73.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.171111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.28,
    y: 145.82
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.56,
    y: 109.05,
    width: 79.44,
    height: 73.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.505714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.28,
    y: 145.82
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.28,
    y: 182.6,
    width: 79.13,
    height: 74.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.409999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.845,
    y: 219.82999999999998
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.28,
    y: 257.05,
    width: 79.13,
    height: 85.25,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.304285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.845,
    y: 299.675
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.28,
    y: 342.31,
    width: 79.13,
    height: 85.86,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.89125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.845,
    y: 385.24
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.28,
    y: 428.17,
    width: 79.13,
    height: 88.19,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.304285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.845,
    y: 472.265
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.28,
    y: 516.36,
    width: 79.13,
    height: 90.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.7825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.845,
    y: 561.845
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.28,
    y: 607.33,
    width: 79.13,
    height: 92.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.825999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.845,
    y: 653.6650000000001
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.41,
    y: 182.6,
    width: 79.23,
    height: 101.09,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.31857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.025,
    y: 233.14499999999998
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304.64,
    y: 182.6,
    width: 92.9,
    height: 101.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.09,
    y: 233.14499999999998
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.54,
    y: 182.6,
    width: 97.36,
    height: 101.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.22,
    y: 233.14499999999998
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.9,
    y: 182.6,
    width: 97.7,
    height: 101.09,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.2125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.75,
    y: 233.14499999999998
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.61,
    y: 182.6,
    width: 107.39,
    height: 101.09,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.63625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.3050000000001,
    y: 233.14499999999998
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.41,
    y: 283.68,
    width: 149.1,
    height: 77.7,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.96,
    y: 322.53000000000003
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.41,
    y: 361.39,
    width: 149.1,
    height: 96.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.824285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.96,
    y: 409.775
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.41,
    y: 458.16,
    width: 149.1,
    height: 241.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.6375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.96,
    y: 579.08
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.51,
    y: 283.68,
    width: 157.36,
    height: 263.74,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.22666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.19,
    y: 415.55
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 531.87,
    y: 283.68,
    width: 168.13,
    height: 263.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 42.0325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.935,
    y: 415.55
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.51,
    y: 547.43,
    width: 325.49,
    height: 152.57,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.42833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 537.255,
    y: 623.7149999999999
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2000);
export default __webpack_public_path__ + "static/media/2000.499327a344080cdb2b58e3c5cce421f6.svg";
export { ForwardRef as ReactComponent };